{
    "accept": "Accepteren",
    "action_open_in_external_app": "Openen in ${1}",
    "back": "Terug",
    "cancel": "Annuleren",
    "choose": "Kies",
    "content_missing": "De inhoud ontbreekt.",
    "delete": "Verwijderen",
    "description": "Beschrijving",
    "dismiss": "Verwerpen",
    "done": "Klaar",
    "donor_feedback_anonymized": "We hebben uw gegevens al geanonimiseerd om redenen van gegevensbescherming.",
    "donor_feedback_incorrect_link": "De link die u gebruikt is niet correct - controleer of u de volledige link gebruikt die u werd toegestuurd.",
    "donor_feedback_not_found": "Helaas is deze link ongeldig, dit kan een van de volgende redenen hebben:",
    "error_occurred": "Er is een fout opgetreden",
    "expired": "Verlopen",
    "failed": "Niet geslaagd",
    "field_error_address_unsupported_country": "Adres niet in aanvaard land",
    "field_error_any": "Geef ten minste één van deze velden op: ${1}",
    "field_error_date_invalid": "Geef een geldige datum op",
    "field_error_date_max": "De datum moet ${1} of eerder zijn",
    "field_error_date_min": "De datum moet ${1} of later zijn",
    "field_error_date_range_max": "De datum moet voor ${1} liggen",
    "field_error_date_range_min": "De datum moet na ${1} liggen",
    "field_error_email": "Geef een geldig e-mailadres op",
    "field_error_length_max": "Dit veld is beperkt tot ${1} tekens",
    "field_error_length_min": "Geef minimaal ${1} tekens op",
    "field_error_max": "De maximumwaarde is ${1}",
    "field_error_min": "De minimumwaarde is ${1}",
    "field_error_pattern": "De invoer is ongeldig",
    "field_error_phone_invalid": "Gelieve een geldig telefoonnummer op te geven",
    "field_error_phone_starts_with_zero": "Er bestaat al een landcode. Verwijder de voorloop \"0\" uit het telefoonnummer.",
    "field_error_required": "Gelieve dit veld in te vullen",
    "field_is_required": "Dit veld is verplicht",
    "field_placeholder_address_search": "Voer een locatie in",
    "field_select_not_found": "${1}' kon niet worden gevonden",
    "font_big": "groot lettertype",
    "font_medium": "middelgroot lettertype",
    "font_small": "klein lettertype",
    "last_attempt": "Laatste poging",
    "last_upload": "Laatste upload",
    "link_sent": "Link verzonden, gelieve te controleren",
    "network_error": "Netwerkfout",
    "next": "Volgende",
    "no_results": "Geen resultaten",
    "offline": "offline",
    "ok": "Ok",
    "online": "online",
    "open": "Openen",
    "page_not_found_description": "De pagina die je probeerde op te vragen bestaat niet. Misschien heb je de URL verkeerd getypt.",
    "page_not_found_link": "Terug naar de startpagina.",
    "page_not_found_title": "Pagina niet gevonden",
    "passed": "Geslaagd",
    "result": "Resultaat",
    "retry": "Opnieuw proberen",
    "save": "Opslaan",
    "state_done": "Klaar",
    "state_not_uploaded": "Niet geüpload",
    "state_pending": "In behandeling",
    "state_refused": "Geweigerd",
    "state_uploading": "Aan het uploaden",
    "submit": "Indienen",
    "type": "Type",
    "uploading": "Bezig met uploaden..."
}